import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackEvent } from '../services/tracking'

/**
 * Automatically tracks page_view and page_view_ended events on route changes.
 * Must be rendered inside <BrowserRouter>.
 */
export function usePageTracking(): void {
  const location = useLocation()
  const prevPath = useRef(location.pathname)
  const enteredAt = useRef(performance.now())

  useEffect(() => {
    const now = performance.now()

    // Emit page_view_ended for the previous page on navigation
    if (prevPath.current !== location.pathname) {
      trackEvent('page_view_ended', {
        path: prevPath.current,
        duration_ms: Math.round(now - enteredAt.current),
      })
    }

    trackEvent('page_view', { path: location.pathname })
    prevPath.current = location.pathname
    enteredAt.current = now
  }, [location.pathname])
}
